
import React, { Component } from 'react'
import './Holidays.css'
import YearList from '../../../YearList'
import dayjs from 'dayjs'

export default class Holidays extends Component {
    constructor(props) {
        super(props)
        this.state = {
            report: false,
            dopHolidays: false,
            selected_monthID: 1,
            selected_dayID: 1,
            holidayNAME: null,
            id_holiday: null,
            calendar: false,
            holidayDATE: null,
            HolydayDays: [],
        }
    }

    SelectStatusHoliday = (dopHolidays) => {
        this.setState({
            dopHolidays
        })
        this.props.SelectStatusHoliday(dopHolidays ? 'dinamic' : 'const')
    }

    activeUpdateRow(activerow, activerow_ind) {
        this.setState({ activerow, activerow_ind })
        if (activerow === 0) {
            this.setState({
                selected_dayID: 1,
                selected_monthID: 1,
                holidayNAME: null,
                holidayDATE: null
            })
        }
        if (this.props.selected_menu === 8 && activerow === 1) {
            const { Holydays } = this.props
            console.log('Holidays', Holydays)
            if (!this.state.dopHolidays) {
                this.setState({
                    selected_dayID: Holydays[activerow_ind]?.holiday_const_day,
                    selected_monthID: Holydays[activerow_ind]?.holiday_const_month,
                    holidayNAME: Holydays[activerow_ind]?.holiday_const_name
                })
            } else {
                this.setState({
                    holidayDATE: Holydays[activerow_ind]?.holiday_dynamic_date,
                    holidayNAME: Holydays[activerow_ind]?.holiday_dynamic_name
                })
            }
        }
        this.props.activeUpdateRow(activerow, activerow_ind)
    }
    plusInsertRow(insertRow) {
        this.setState({ insertRow })
        this.setState({
        })
        if (insertRow === 0) {
            this.setState({
                selected_dayID: 1,
                selected_monthID: 1,
                holidayNAME: null
            })
        }
        this.props.plusInsertRow(insertRow)
    }

    sureDelete(SureDel, holidayname, id_holiday) {
        this.props.sureDelete(SureDel, holidayname)
        this.setState({ id_holiday })
    }

    postHolidaysUpdate = (type, id_holiday) => {
        if (!this.state.dopHolidays) {
            this.props.postHolidaysUpdate(type, this.state.selected_dayID, this.state.selected_monthID, this.state.holidayNAME, null, this.props.id_AVN_User, id_holiday)
        } else {
            this.props.postHolidaysUpdate(type, this.state.selected_dayID, this.state.selected_monthID, this.state.holidayNAME, this.state.holidayDATE, this.props.id_AVN_User, id_holiday)
        }
        this.activeUpdateRow(0, null)
    }
    postHolidaysInsert = (type) => {
        if (!this.state.dopHolidays) {
            this.props.postHolidaysInsert(type, this.state.selected_dayID, this.state.selected_monthID, this.state.holidayNAME, null, this.props.id_AVN_User)
        } else {
            this.props.postHolidaysInsert(type, this.state.selected_dayID, this.state.selected_monthID, this.state.holidayNAME, this.state.holidayDATE, this.props.id_AVN_User)
        }
        this.plusInsertRow(0)
    }
    postHolidaysDelete = () => {
        if (!this.state.dopHolidays) {
            this.props.postHolidaysDelete('const', this.state.id_holiday)
        } else {
            this.props.postHolidaysDelete('dinamic', this.state.id_holiday)
        }
        this.sureDelete(0, null, null)
    }

    changeDayID = (e) => {
        this.setState({
            selected_dayID: e.target.value
        })
    }

    changeMonthID = (id) => {
        if (id == 0) {
            if ((this.state.selected_monthID - 1) < 1) {
                this.setState({
                    selected_monthID: 12,
                })
            } else {
                this.setState(prevState => ({
                    selected_monthID: prevState.selected_monthID - 1
                }));
            }
        } else {
            if ((this.state.selected_monthID + 1) > 12) {
                this.setState({
                    selected_monthID: 1
                })
            } else {
                this.setState(prevState => ({
                    selected_monthID: prevState.selected_monthID + 1
                }));
            }
        }
    }

    changeHolidayName = (e) => {
        this.setState({
            holidayNAME: e.target.value
        })
    }

    changeHolidayDate = (e) => {
        this.setState({
            holidayDATE: e.target.value
        })
    }
    render() {

        const {
            Holydays,
            MonthList,
            DimDate,
        } = this.props

        const { selected_monthID } = this.state
        return (
            <div className="HolidaysContainer" >
                <div className='Admin_container'>
                    <div className='Admin_menu'>
                        <h3 className={!this.state.dopHolidays && 'active_left'}
                            onClick={() => this.SelectStatusHoliday(false)}>Основные</h3>

                        <h3 className={this.state.dopHolidays && 'active_right'}
                            onClick={() => this.SelectStatusHoliday(true)}>Дополнительные</h3>
                    </div>
                    <div className='Admin_instruments' >
                    </div>
                </div>
                {!this.state.dopHolidays ?
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '60px' }}>№</th>
                                    <th style={{ width: '10%', textAlign: 'center' }}>День</th>
                                    <th style={{ width: '20%', textAlign: 'center' }}>Месяц</th>
                                    <th style={{ width: '1fr', textAlign: 'left' }}>Наименование</th>
                                    <th style={{ width: '80px', textAlign: 'center' }}>Действия</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Holydays && Holydays.length ? Holydays.map((item, index) => (
                                    <tr key={'Holiday' + index} className={this.props.activerow === 1 && this.props.activerow_ind === index && 'insert_row'}>
                                        <td>{index + 1}</td>
                                        <td>
                                            {this.props.activerow === 1 && this.props.activerow_ind === index ?
                                                <input
                                                    type='number'
                                                    onChange={this.changeDayID}
                                                    defaultValue={item?.holiday_const_day}
                                                    max='31'
                                                    min='1'
                                                /> : item?.holiday_const_day
                                            }
                                        </td>
                                        <td>{this.props.activerow === 1 && this.props.activerow_ind === index ?
                                            <div className='Holidays_month_wrapper' onWheel={() => this.scrollMonths()} id='monthsWrapper'>
                                                <p>{MonthList?.length ? MonthList[selected_monthID - 1]?.months : null}</p>
                                                <nav>
                                                    <i class="fas fa-caret-up" onClick={() => this.changeMonthID(0)}></i>
                                                    <i class="fas fa-caret-down" onClick={() => this.changeMonthID(1)}></i>
                                                </nav>
                                            </div>
                                            :
                                            MonthList?.length ? MonthList.filter(m => m.id_months == item?.holiday_const_month)[0]?.months : null}
                                        </td>
                                        <td style={{
                                            textAlign: 'left',
                                            padding: this.props.activerow === 1 && this.props.activerow_ind === index ? '10px' : '10px',
                                            verticalAlign: this.props.activerow === 1 && this.props.activerow_ind === index ? 'top' : 'middle'
                                        }}>
                                            {this.props.activerow === 1 && this.props.activerow_ind === index ?
                                                <input
                                                    type='text'
                                                    onChange={this.changeHolidayName}
                                                    defaultValue={item.holiday_const_name}
                                                    style={{ textAlign: 'left' }}
                                                /> : item.holiday_const_name
                                            }
                                        </td>
                                        <td>
                                            {
                                                (this.state.selected_dayID !== item?.holiday_const_day ||
                                                    this.state.selected_monthID !== item?.holiday_const_month ||
                                                    this.state.holidayNAME !== item?.holiday_const_name)
                                                    && this.props.activerow_ind === index ?
                                                    <i className="fas fa-save" onClick={() => this.postHolidaysUpdate('const', item.id_holiday_const)}></i> : null
                                            }
                                            {this.props.activerow === 1 && this.props.activerow_ind === index ?
                                                <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                                <>
                                                    <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)} title='Изменить'></i>
                                                    <i className="far fa-trash-alt" onClick={() => this.sureDelete(1, item?.holiday_const_name, item?.id_holiday_const)}></i>
                                                </>}
                                        </td>
                                    </tr>)) : <tr><td colSpan='5'>Пока нет данных...</td></tr>}
                                {this.props.insertRow === 1 ?
                                    <tr className={this.props.insertRow === 1 && 'insert_row'}>
                                        <td>{'#'}</td>
                                        <td>
                                            <input
                                                type='number'
                                                onChange={this.changeDayID}
                                                defaultValue='1'
                                                max='31'
                                                min='1'
                                            />
                                        </td>
                                        <td>
                                            <div className='Holidays_month_wrapper' >
                                                <p>{MonthList?.length ? MonthList[selected_monthID - 1].months : null}</p>
                                                <nav>
                                                    <i class="fas fa-caret-up" onClick={() => this.changeMonthID(0)}></i>
                                                    <i class="fas fa-caret-down" onClick={() => this.changeMonthID(1)}></i>
                                                </nav>
                                            </div>
                                        </td>
                                        <td style={{
                                            textAlign: 'left',
                                            padding: '10px',
                                            verticalAlign: 'middle'
                                        }}>
                                            <input
                                                type='text'
                                                onChange={this.changeHolidayName}
                                                style={{ textAlign: 'left' }}
                                                placeholder='Введите название праздника'
                                            />
                                        </td>
                                        <td>
                                            {this.state.holidayNAME ?
                                                <>
                                                    <i className="fas fa-save" onClick={() => this.postHolidaysInsert('const')}></i>
                                                    <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                                </> :
                                                <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                            }
                                        </td>
                                    </tr> : null
                                }
                                <tr><td className='Plus_row' onClick={() => this.plusInsertRow(1)} title='Добавить'>+</td></tr>
                            </tbody>
                        </table>
                    </div> :

                    /*----------------------------- Дополнительные праздничные дни-------------------------- */
                    <div>
                        <div className='Search_container'>
                            <div className="selectors_container" style={{ gridTemplateColumns: '0.5fr 0.5fr 1fr ' }}>
                                <div>
                                    <p>Год:</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.props.OpenSelectorOptions(1, 'years') :
                                            this.props.OpenSelectorOptions(0, null)} >
                                            {this.props.id_a_year > 0 ? this.props.year : <b>Выберите год</b>}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name == 'years' ?
                                            <span>
                                                {YearList.map(({ id, name }, offset) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_a_year === id && '#7F9CF5' }}
                                                            key={offset} onClick={() => this.props.ChangeYear(id, name)}>
                                                            {name}
                                                        </p>
                                                    )
                                                })}
                                            </span> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '60px' }}>№</th>
                                    <th style={{ width: '30%', textAlign: 'center' }}>Дата</th>
                                    <th style={{ width: '1fr', textAlign: 'left' }}>Наименование</th>
                                    <th style={{ width: '80px', textAlign: 'center' }}>Действия</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Holydays && Holydays.length ? Holydays.map((item, index) => (
                                    <tr key={'Holiday_dop' + index} className={this.props.activerow === 1 && this.props.activerow_ind === index && 'insert_row'}>
                                        <td>{index + 1}</td>
                                        <td>                                            {this.props.activerow === 1 && this.props.activerow_ind === index ?
                                            <input
                                                type='date'
                                                onChange={this.changeHolidayDate}
                                                defaultValue={dayjs(item?.holiday_dynamic_date).format('YYYY-MM-DD')}
                                            />
                                            : dayjs(item?.holiday_dynamic_date).format('DD-MM-YYYY')}
                                        </td>
                                        <td style={{
                                            textAlign: 'left',
                                            padding: this.props.activerow === 1 && this.props.activerow_ind === index ? '10px' : '10px',
                                            verticalAlign: this.props.activerow === 1 && this.props.activerow_ind === index ? 'top' : 'middle'
                                        }}>
                                            {this.props.activerow === 1 && this.props.activerow_ind === index ?
                                                <input
                                                    type='text'
                                                    onChange={this.changeHolidayName}
                                                    defaultValue={item?.holiday_dynamic_name}
                                                    style={{ textAlign: 'left' }}
                                                /> : item?.holiday_dynamic_name
                                            }
                                        </td>
                                        <td>
                                            {
                                                (this.state.holidayDATE !== item.holiday_dynamic_date || this.state.holidayNAME !== item.holiday_dynamic_name)
                                                    && this.props.activerow_ind === index ?
                                                    <i className="fas fa-save" onClick={() => this.postHolidaysUpdate('dinamic', item.id_holiday_dynamic)}></i> : null
                                            }
                                            {this.props.activerow === 1 && this.props.activerow_ind === index ?
                                                <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                                <>
                                                    <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)} title='Изменить'></i>
                                                    <i className="far fa-trash-alt" onClick={() => this.sureDelete(1, item?.holiday_dynamic_name, item?.id_holiday_dynamic)}></i>
                                                </>}
                                        </td>
                                    </tr>)) : <tr><td colSpan='5'>Пока нет данных...</td></tr>}
                                {this.props.insertRow === 1 ?
                                    <tr className={this.props.insertRow === 1 && 'insert_row'}>
                                        <td>{'#'}</td>
                                        <td>
                                            <input
                                                type='date'
                                                onChange={this.changeHolidayDate}
                                            />
                                        </td>
                                        <td style={{
                                            textAlign: 'left',
                                            padding: '10px'
                                        }}>
                                            <input
                                                type='text'
                                                onChange={this.changeHolidayName}
                                                style={{ textAlign: 'left' }}
                                                placeholder='Введите название праздника'
                                            />
                                        </td>
                                        <td>
                                            {this.state.holidayNAME && this.state.holidayDATE ?
                                                <>
                                                    <i className="fas fa-save" onClick={() => this.postHolidaysInsert('dinamic')}></i>
                                                    <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                                </> :
                                                <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                            }
                                        </td>
                                    </tr> : null
                                }
                                <tr><td className='Plus_row' onClick={() => this.plusInsertRow(1)} title='Добавить'>+</td></tr>
                            </tbody>
                        </table>
                    </div>
                }

                {
                    this.props.SureDel === 1 &&
                    <div className='Redact_okno_bg'>
                        <div className="Delet_Sure">
                            <p>
                                <span>Вы действительно хотите удалить запись:</span> <br />
                                {this.props.t_fio_delete}
                            </p>
                            <label
                                className="save_button"
                                onClick={() =>
                                    this.postHolidaysDelete()
                                }
                            >
                                <i className="fas fa-trash-alt"> </i>Удалить
                            </label>
                            <label
                                className="cancel_button"
                                onClick={() => this.sureDelete(-1, null)}
                            >
                                <i className="fas fa-ban"></i>Отмена
                            </label>
                        </div>
                    </div>
                }
            </div>
        )
    }
}


